import init from '../../../js/init';

const name = 'year-slider';
const selector = '.year-slider';
const sliderSelector = '.slider';
const cardSelector = '.card';
const yearButtonSelector = '.year-pager__button';
const yearButtonActiveClass = `${yearButtonSelector}--active`.substring(1);
const yearButtonDisabledClass = `${yearButtonSelector}--disabled`.substring(1);
const yearAttribute = 'data-year';

init(Drupal, name, selector, root => {
  const slider = root.querySelector(sliderSelector);
  const cards = root.querySelectorAll(cardSelector);
  const yearButtons = root.querySelectorAll(yearButtonSelector);

  const initYearButtons = () => {
    yearButtons.forEach(button => {
      const buttonYear = button.innerHTML.trim();

      if (
        [...cards].findIndex(card => card.getAttribute(yearAttribute).trim() === buttonYear) === -1
      )
        button.classList.add(yearButtonDisabledClass);
    });
  };

  const setYearActive = year => {
    yearButtons.forEach(button => {
      const buttonYear = button.innerHTML.trim();

      button.classList.remove(yearButtonActiveClass);
      if (buttonYear === year) button.classList.add(yearButtonActiveClass);
    });
  };

  const onYearChange = e => {
    const yearButton = e.currentTarget;
    const year = yearButton.innerHTML.trim();

    const idx = [...cards].findIndex(card => {
      const cardYear = card.getAttribute(yearAttribute).trim();
      return cardYear === year;
    });

    if (idx === -1) return;

    const event = new CustomEvent('goto', { detail: { index: idx } });
    slider.dispatchEvent(event);
  };

  const onSliderMove = ({ detail: { dest } }) => {
    const cardYear = cards[dest].getAttribute(yearAttribute).trim();
    setYearActive(cardYear);
  };

  initYearButtons();

  yearButtons.forEach(button => (button.onclick = onYearChange));
  root.addEventListener('slider-move', onSliderMove);
});
